<div
  class="text-center relative color-light border-radius-5 overflow-hidden m-a"
  style="max-width: fit-content">
  <!-- Header -->
  <cp-widget-header
    text="Remortgage Guide"
    icon="map-location"
    [isAbsolutePosition]="true"
    variant="remortgage-guide" />

  <!-- Video -->
  <div class="absolute z-index-3 bottom-3" visibility (visibilityChange)="playVideo($event)"></div>
  <div class="relative">
    <video
      class="border-radius-5"
      #bestDealVid
      (ended)="toggleVideoEnded(true)"
      style="width: 100%"
      playsinline
      [muted]="muted"
      [poster]="'dashboard-widget-poster-door.jpg' | brandingAssetPath">
      @if (!isCompanyBranded) {
        <source src="/assets/videos/door.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      }
    </video>
  </div>

  <!-- Contents -->
  <ng-container *ngTemplateOutlet="videoContent" />
  <ng-container *ngTemplateOutlet="carousel" />
</div>

<!-- Text during video play -->
<ng-template #videoContent>
  <div class="w-100 h-100 z-index-1 absolute video-content pt-5 pb-3">
    <ng-container *ngTemplateOutlet="title" />

    <div class="text-14 px-5 bottom-3 pb-5 text-center">
      As of today you're on the right deal. But don't worry, we'll continue to monitor your mortgage
      every day to ensure that you always remain on the right deal for you.
    </div>
  </div>
</ng-template>

<ng-template #carousel>
  <div
    class="w-100 h-100 absolute z-index-2 bg-remortgage-guide clickable-content pt-5 px-3 gap-3"
    [ngClass]="{ 'view-content': videoEnded }">
    <ng-container *ngTemplateOutlet="title" />
    <div class="text-14 text-center px-3">
      Don't worry, we’ll make this process smooth and simple. Here’s how we’ll guide you through the
      next steps to get the best deal:
    </div>

    <div style="align-self: center">
      <cui-carousel [itemsLength]="3" arrowButtonStyleClass="fill">
        <ng-container
          [ngTemplateOutlet]="stepItem"
          [ngTemplateOutletContext]="{
            data: {
              tagText: 'Step 1',
              text: 'Clean and repair your finances',
              img: 'remortgage-guide-step-1-icon.png',
            },
          }" />

        <ng-container
          [ngTemplateOutlet]="stepItem"
          [ngTemplateOutletContext]="{
            data: {
              tagText: 'Step 2',
              text: 'Set your future goals',
              img: 'remortgage-guide-step-2-icon.png',
            },
          }" />

        <ng-container
          [ngTemplateOutlet]="stepItem"
          [ngTemplateOutletContext]="{
            data: {
              tagText: 'Step 3',
              text: 'Choose the right deal',
              img: 'remortgage-guide-step-3-icon.png',
            },
          }" />
      </cui-carousel>
    </div>

    <div class="pb-4">
      <button
        [routerLink]="['/', paths.PLATFORM, paths.platform.REMORTGAGE_GUIDE]"
        [queryParams]="{ propertyId, remainingMonths }"
        class="p-button p-button-remortgage-guide w-fit centered m-a">
        Learn more
      </button>
    </div>
  </div>
</ng-template>

<ng-template #title>
  <div class="text-28 bold-800 px-3 text-center pt-2">
    @if (isExperianCompany$ | async) {
      It looks like you need to remortgage in {{ remainingMonths }} month{{
        remainingMonths > 1 ? "s" : ""
      }}
    } @else {
      {{ remainingMonths }} Months to Renew Your Mortgage
    }
  </div>
</ng-template>

<ng-template #stepItem let-data="data">
  <div
    class="bg-remortgage-guide-secondary color-light p-2 mx-3 border-radius-3"
    [routerLink]="['/', paths.PLATFORM, paths.platform.REMORTGAGE_GUIDE]"
    [queryParams]="{ propertyId, remainingMonths }">
    <div
      class="bold-800 text-10 py-1 bg-primary border-radius-3 w-fit m-a px-3"
      style="margin-top: -1rem">
      {{ data.tagText }}
    </div>
    <div class="layout-auto-fr align-items-center gap-3">
      <img style="height: 4rem" [src]="data.img | brandingAssetPath" alt="" />
      <div class="text-18 bold-700 text-start pr-1">{{ data.text }}</div>
    </div>
  </div>
</ng-template>
